export { default } from "./WeeklyTrendLevel";
